/* Shared, DOM-free catalogue and geometry rules. Unknown facts stay unknown. */
(function(scope){
 const schema=2,smallResultLimit=12;
 const facetKinds=['shape','style','color','origin','construction'];
 const colorGroups={light:['cream','white','beige'],dark:['black','grey','black-white'],warm:['red','orange','yellow','terracotta-rust'],rose:['pink','purple','burgundy']};
 const matchesColor=(colors,value)=>(colorGroups[value]||[value==='gray'?'grey':value]).some(c=>colors.includes(c));
 const eligible=(p,s)=>p.discoverable&&(p.available!==false||p.includeUnavailable===true)&&Object.entries(s).every(([k,v])=>!v||(k==='shape'?p.shape===v:k==='color'?matchesColor(p.color||[],v):p[k]?.includes(v)));
 function normalize(anchor,detail,currency){
  const tags=(anchor.dataset.tags||'').toLowerCase().split('|').filter(Boolean);
  const f=anchor.facets||{};
  return {id:String(detail?.id||anchor.dataset.productId),handle:new URL(anchor.href).pathname.split('/').filter(Boolean).pop(),title:detail?.title||anchor.getAttribute('aria-label'),url:anchor.href,
   available:detail?.available??(anchor.dataset.available!=='false'),includeUnavailable:anchor.closest?.('vorug-infinite-collection')?.dataset.includeUnavailable==='true',discoverable:anchor.dataset.discoverable!=='false',shape:f.shape||null,style:[...new Set(f.style||[])],color:[...new Set(f.color||[])],origin:[...new Set(f.origin||[])],construction:[...new Set(f.construction||[])],
   material:tags.includes('jute')?'Jute':tags.includes('wool')?'Wool':null,currency:currency||null,price:detail?.price_min??detail?.price??null,priceMax:detail?.price_max??detail?.price??null,
   variants:detail?.variants||[],image:anchor.querySelector('img')?.dataset?.src||anchor.querySelector('img')?.src,provenance:{facets:'collection metadata; local shape review',commerce:detail?'public product snapshot':'not loaded'}};
 }
 // One packed lattice for every facet and count. Families change ordering,
 // never the pitch, origin, or number of columns.
 function layout(n,width,height,availableHeight=height-240){
  const baseCols=width<1100?3:6;
  const maxCellWidth=height<=520?Math.max(24,availableHeight/1.12):Infinity;
  const cols=Math.max(baseCols,Math.ceil(width/maxCellWidth/3)*3),w=width/(width<1100?2:5.5),h=w*1.12,rows=Math.ceil(n/cols);
  // A region must cover two screens in both axes. Exact factors keep every
  // product unique inside it: no tail padding, diagonal alias or empty slot.
  const minCols=cols*2+3,minRows=Math.ceil(height/h)*2+2;
  let regionCols=0,regionRows=0,best=Infinity;
  if(n>smallResultLimit)for(let c=minCols;c<=n/minRows;c+=3){
   if(n%c)continue;const r=n/c,score=Math.abs(Math.log(c*w/(r*h)));
   if(score<best){best=score;regionCols=c;regionRows=r;}
  }
  if(n>smallResultLimit&&!regionCols){
   regionCols=minCols;
   let a=n,b=regionCols;while(b){const remainder=a%b;a=b;b=remainder;}
   regionRows=n/a;regionRows*=Math.max(1,Math.ceil(minRows/regionRows));
  }
  const finite=!regionCols;
  return {w,h,cols,stride:cols,regionCols,regionRows,px:finite?cols:regionCols,py:finite?rows:regionRows,finite,rows,maxPanX:finite?Math.max(0,Math.min(n,cols)*w-width):0,maxPanY:finite?Math.max(0,rows*h-availableHeight):0,ox:0,oy:64,lastOffset:0};
 }
 function familyLayout(groups,width,height,availableHeight=height-240){
  const packed=groups.flat(),l=layout(packed.length,width,height,availableHeight);
  return {...l,groups,packed,repeatPacked:packed,blocks:l.cols/3};
 }
 const mod=(n,d)=>((n%d)+d)%d;
 function cellOffset(){return 0;}

 function indexAt(col,row,l,n){
  if(l.finite&&(col<0||row<0||col>=l.cols||row>=l.rows))return -1;
  const repeat=l.repeatPacked||l.packed,period=repeat?.length||n;
  const i=l.finite?row*l.cols+col:mod(row,l.regionRows)*l.regionCols+mod(col,l.regionCols);
  const offset=l.finite?i:mod(i,period),mapped=repeat?.[offset]??offset;
  return mapped<n?mapped:-1;
 }
 function anchor(x,y,l){return {col:-x/l.w,row:-y/l.h};}
 function restored(a,l){return {x:-a.col*l.w||0,y:-a.row*l.h||0};}
 function sameLayout(a,b){return !!a&&!!b&&['w','h','cols','stride','regionCols','regionRows','finite','rows','ox','oy','maxPanX','maxPanY','lastOffset'].every(k=>a[k]===b[k]);}
 function coordinates(index,l){
  if(index<0)return null;
  if(l.packed){index=l.packed.indexOf(index);if(index<0)return null;}
  const cols=l.finite?l.cols:l.regionCols;return {col:index%cols,row:Math.floor(index/cols)};
 }
 function positionFor(index,l,cx,cy){
  const cell=coordinates(index,l);if(!cell)return {x:0,y:0};
  const offset=cellOffset(cell.col,cell.row,l)+(l.finite&&cell.row===l.rows-1?l.lastOffset:0);
  const x=cx-(cell.col+.5)*l.w-(l.ox||0)-offset,y=cy-(cell.row+.5)*l.h-(l.oy||0);
  return l.finite?{x:Math.max(-l.maxPanX,Math.min(0,x))||0,y:Math.max(-l.maxPanY,Math.min(0,y))||0}:{x,y};
 }
 function imageReadiness(images,expired=false){return !images.length||images.every(i=>i.loaded||i.failed)||(expired&&images.some(i=>i.loaded));}
 function imageWidth(cellWidth,dpr=1,nativeWidth=Infinity){return Math.min(nativeWidth||Infinity,1800,Math.max(320,Math.ceil(cellWidth*Math.max(1,dpr||1)/80)*80));}
 function selectionKey(s){return JSON.stringify(facetKinds.map(k=>s?.[k]||''));}
 function cleanSelection(value,allowed){
  return Object.fromEntries(facetKinds.map(kind=>{
   let entry=typeof value?.[kind]==='string'?value[kind].trim():'';
   if(kind==='shape')entry=({area:'Area',areas:'Area','area-rug':'Area',runner:'Runner',runners:'Runner',round:'Round',rounds:'Round','round-rug':'Round'})[entry.toLowerCase()]||'';
   else{entry=entry.toLowerCase();if(entry==='all')entry='';if(kind==='color')entry=({gray:'grey','cream-ivory':'cream','cream-and-ivory':'cream','chocolate-brown':'brown','yellow-mustard':'yellow'})[entry]||entry;if(kind==='origin'&&entry==='taznakht-flatweave')entry='taznakht';if(kind==='construction'&&entry==='hand-knotted')entry='pile';}
   return [kind,(allowed[kind]?.has(entry)||(!entry))?entry:''];
  }));
 }
 function catalogueEntry(params,remembered,allowed,entry=null){
  const previous=cleanSelection(remembered,allowed),shop=params.get('shop')==='all';
  const explicit=facetKinds.some(kind=>params.has(kind)),native=entry!==null;
  const requested=Object.fromEntries(facetKinds.map(kind=>[kind,params.has(kind)?params.get(kind):native&&!shop?entry[kind]||'':'']));
  const selection=cleanSelection(shop||explicit||native?requested:previous,allowed);
  return {selection,fresh:shop||((explicit||native)&&selectionKey(previous)!==selectionKey(selection))};
 }
 function facetLabel(kind,value,buttonValue,buttonLabel){
  if(buttonLabel&&!(kind==='color'&&value&&value!==buttonValue))return buttonLabel;
  if(kind==='construction')return {pile:'Hand-knotted',flatweave:'Flatweave'}[value]||value;
  return String(value||'').replaceAll('-',' ').split(' ').map(word=>word?word[0].toUpperCase()+word.slice(1):'').join(' ');
 }
 function recordFilter(history,previous,next){
  if(selectionKey(previous)===selectionKey(next))return history;
  if(history.length&&selectionKey(history.at(-1).after)!==selectionKey(previous))history=[];
  return [...history,{before:{...previous},after:{...next}}].slice(-16);
 }
 function undoFilter(history,current){
  const last=history?.at(-1);return last&&selectionKey(last.after)===selectionKey(current)?last:null;
 }
 // Recovery choices change one facet only and use the same eligibility rules as the field.
 function recoverySuggestions(products,selection,choices,limit=3){
  const current=products.filter(p=>eligible(p,selection)).length,result=[];
  for(const kind of ['color','style','shape','origin','construction']){
   const candidates=(choices[kind]||[]).filter(choice=>choice.value!==(selection[kind]||'')).map(choice=>{
    const next={...selection,[kind]:choice.value},count=products.filter(p=>eligible(p,next)).length;
    return {kind,value:choice.value,label:choice.label,selection:next,count};
   }).filter(choice=>choice.count>current);
   candidates.sort((a,b)=>Number(!a.value)-Number(!b.value)||a.count-b.count||a.label.localeCompare(b.label));
   if(candidates[0])result.push(candidates[0]);
  }
  return result.slice(0,limit);
 }
 function floorPose(u,v,cellWidth){
  const period=Math.max(1,cellWidth*.5);
  return {period,x:mod(u*cellWidth,period),y:mod(v*cellWidth,period)};
 }
 function assignment(seed,experiment){let h=2166136261;for(const c of `${experiment}:${seed}`){h^=c.charCodeAt(0);h=Math.imul(h,16777619)}return (h>>>0)%2?'relevance':'curated';}
 function representatives(products,values){
  const used=new Set(),result=new Map();
  const family=p=>p.handle.replace(/-(area-rug|round-rug|runner)$/,'');
  // Specific styles get first choice; broad styles use a different design family.
  const ordered=values.filter(Boolean).sort((a,b)=>products.filter(p=>p.style.includes(a)).length-products.filter(p=>p.style.includes(b)).length||a.localeCompare(b));
  for(const value of ordered){
   const candidates=products.filter(p=>p.style.includes(value));
   const score=p=>(used.has(family(p))?-100:0)+(p.shape==='Area'?10:0)-p.style.length;
   candidates.sort((a,b)=>score(b)-score(a)||a.handle.localeCompare(b.handle));
   if(candidates[0]){result.set(value,[candidates[0]]);used.add(family(candidates[0]));}
  }
  const collage=[];const collageFamilies=new Set();
  for(const p of [...result.values()].flat().concat(products))if(!collageFamilies.has(family(p))){collage.push(p);collageFamilies.add(family(p));if(collage.length===3)break}
  result.set('',collage);return result;
 }
 function revealOffset(start,size,scroll,viewport,total,padding=8){
  let next=scroll;
  if(start-padding<scroll)next=start-padding;
  else if(start+size+padding>scroll+viewport)next=start+size+padding-viewport;
  return Math.max(0,Math.min(Math.max(0,total-viewport),next));
 }
 scope.VorugDiscoveryCore={schema,smallResultLimit,facetKinds,eligible,normalize,layout,familyLayout,cellOffset,indexAt,anchor,restored,sameLayout,coordinates,positionFor,imageReadiness,imageWidth,selectionKey,cleanSelection,catalogueEntry,facetLabel,recordFilter,undoFilter,recoverySuggestions,floorPose,assignment,representatives,revealOffset,matchesColor,colorGroups};
})(typeof window==='undefined'?globalThis:window);
